export const MESSAGES_SORT_BY_TYPE = {
    TITLE: 'name',
    START_DATE: 'beginDate',
    END_DATE: 'endDate',
    STATUS: 'status',
};
